import { getDeliveryHost } from "@shared/image-url";

// Hosts for the landing-page marketing assets, both overridable per-env via Vite
// build-time env vars (declared in .mise.example.toml). The web client can't read
// the server's `CLOUDFLARE_CATALOG_IMAGE_HOST` / `BUNNY_CANONICAL_HOSTNAME`, so we
// expose `VITE_`-prefixed mirrors (same pattern as VITE_SENTRY_DSN_WEB). Defaults
// match the app-wide image host + the canonical Bunny library, so unset = current
// behavior.
/** This env's image delivery origin — preconnected at boot (main.tsx) since nearly every page loads card art from it. */
export const IMAGE_HOST = (import.meta.env.VITE_CLOUDFLARE_IMAGE_HOST ?? getDeliveryHost()).replace(
  /\/+$/,
  "",
);
const BUNNY_HOST = (import.meta.env.VITE_BUNNY_HOST ?? "vz-a41ed783-b9f.b-cdn.net")
  .replace(/^https?:\/\//, "")
  .replace(/\/+$/, "");

/** Cloudflare Images transform URL for a marketing image R2 key (format=auto). */
export function promoImageUrl(key: string, width: number): string {
  return `${IMAGE_HOST}/cdn-cgi/image/w=${width},f=auto/${key.replace(/^\/+/, "")}`;
}

/** Bunny Stream direct-play URL for a marketing video (guid + rendition filename). */
export function promoVideoUrl(guid: string, rendition: string): string {
  return `https://${BUNNY_HOST}/${guid}/${rendition}`;
}
